export default {
    rooms:{
        en:'Rooms',
        tc:'房間',
        sc:'房间'
    },
    listRooms:{
        en:'List of Rooms',
        tc:'房間列表',
        sc:'房间列表'
    },
    capacity:{
        en:'Capacity',
        tc:'可容納',
        sc:'可容纳'
    },
    roomSize:{
        en:'Room size',
        tc:'房間大小',
        sc:'房间大小'
    },
    bedSize:{
        en:'Bed size',
        tc:'床型',
        sc:'床型'
    },
    amenity:{
        en:'Amenity',
        tc:'酒店設施',
        sc:'酒店设施'
    },
    amenity_1:{
        en:'All rooms are equipped with listed the amenities.',
        tc:'所有房間都配有以下列明之設施',
        sc:'所有房间都配有以下列明之设施'
    },
    amenity_2:{
        en:'For additional amenities, please visit reception.',
        tc:'如有任何額外需要，請聯絡酒店接待處',
        sc:'如有任何额外需要，请联络酒店接待处'
    },
    amenity_3:{
        en:'Please visit our FAQ page for common questions and answers regarding all aspects of Hotel Noum.',
        tc:'酒店設施',
        sc:'amenity'
    },
    faq_0:{
        en:'FAQ',
        tc:'常問問題',
        sc:'常问问题'
    },
    faq_1:{
        en:'Please visit our FAQ page for common questions and answers regarding all aspects of Hotel Noum.',
        tc:'請造訪我們的常見問題頁面，以了解有關各個方面的常見問題和解答。',
        sc:'请造访我们的常见问题页面，以了解有关各个方面的常见问题和解答。'
    },
    icon_1:{
        en:'Non-Smoking',
        tc:'禁煙',
        sc:'禁烟'
    },
    icon_2:{
        en:'Fixed Window',
        tc:'固定窗戶',
        sc:'固定窗户'
    },
    icon_3:{
        en:'Sea View',
        tc:'海景',
        sc:'海景'
    },
    icon_4:{
        en:'Free Wi-Fi',
        tc:'免費 Wi-Fi',
        sc:'免费 Wi-Fi'
    },
    icon_5:{
        en:'Private Bathroom',
        tc:'私人浴室',
        sc:'私人浴室'
    },
    icon_6:{
        en:'Air Conditioning',
        tc:'空調',
        sc:'空调'
    },
    icon_7:{
        en:'Smart TV',
        tc:'智能電視',
        sc:'智能电视'
    },
    icon_8:{
        en:`L'Occitane Soap`,
        tc:`L'Occitane 香皂`,
        sc:`L'Occitane 香皂`
    },
    icon_9:{
        en:`L'Occitane Showergel`,
        tc:`L'Occitane 沐浴露`,
        sc:`L'Occitane 沐浴露`
    },
    icon_10:{
        en:`L'Occitane Shampoo`,
        tc:`L'Occitane 洗髮水`,
        sc:`L'Occitane 洗发水`,
    },
    icon_11:{
        en:`L'Occitane Conditioner`,
        tc:`L'Occitane 潤髮乳`,
        sc:`L'Occitane 护发素`
    },
    icon_12:{
        en:'Queen Bed',
        tc:'大床',
        sc:'大床'
    },
    icon_13:{
        en:'Accessible Room',
        tc:'無障礙房間',
        sc:'无障碍房间'
    },
    icon_14:{
        en:'Refrigerator',
        tc:'冰箱',
        sc:'冰箱'
    }

}